export default function Card({ children, className = "", padding = "p-6" }) {
  return (
    <div
      className={`bg-surface shadow rounded-lg border border-border ${padding} ${className}`}
    >
      {children}
    </div>
  );
}
